<template>
    <v-dialog v-model="props.dialog_parent" max-width="750px" persistent>

        <v-card>
            <v-card-title class="bg-cyan-darken-2">
                <h2 class="text-h4 text-center">Menu Roles</h2>
            </v-card-title>

            <v-card-title>
                <span class="text-h5">
                    <v-icon icon="mdi-pencil" size="samll" color="cyan-darken-2 as-scale"></v-icon>
                    {{ props.formTitleParent }}
                </span>
            </v-card-title>

            <v-container>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-select v-model="props.registro_parent.menu_id" :items="data.menus" label="Menus"
                            item-text="nombre" item-value="id"></v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-select v-model="props.registro_parent.role_id" :items="data.roles" label="Roles" item-text="name"
                            item-value="id"></v-select>
                    </v-col>
                </v-row>

            </v-container>

            
            <!-- Nueva sección para mostrar datos -->
            <v-card>
                <v-card-title>
                    <span class="text-h5">Datos a Editar</span>
                </v-card-title>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="props.registro_parent.menunombre" label="ID Menú" disabled></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="props.registro_parent.rolnombre" label="ID Rol" disabled></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            <!-- Fin de la sección de datos -->
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn variant="outlined" @click="closeDialogChild()" color="red">
                    <v-icon icon="mdi-file-cancel-outline"></v-icon>&nbsp;Cancelar
                </v-btn>
                <v-btn color="cyan-darken-1" variant="outlined" @click="saveChild()">
                    <v-icon icon="mdi-content-save-check-outline"></v-icon>&nbsp;Guardar
                </v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>


<script>
import { defineComponent, onMounted, reactive } from 'vue';
import Menus from "@/http/services/Menus";
import Roles from "@/http/services/Roles";

export default defineComponent({
    props: ["dialog_parent", "registro_parent", "formTitleParent", "errors_validate_parent"],
    emits: ['closeDialogParent', 'saveParent'],
    setup(props, { emit }) {
        const closeDialogChild = () => {
            emit("closeDialogParent");
        }
        const saveChild = () => {
            emit("saveParent");
        }
        const data = reactive({
            menus: [],
            roles: [],
        });
        onMounted(async () => {
            try {
                const selectServiceMenu = new Menus();
                const response = await selectServiceMenu.selectindex();
                console.log("Estos son los datos del Menu para el select", response);

                const selectServiceRole = new Roles();
                const responseroles = await selectServiceRole.selectroles();
                console.log("Estos son los datos de roles", responseroles);

                if (Array.isArray(response)) {
                    const respuestadatos = response.map(item => `${item.id} - ${item.nombre}`);
                    data.menus = respuestadatos;

                    console.log("datos del select de menus", respuestadatos);
                } else {
                    console.error("Los datos cargados no son un array:", response);
                }


                if (Array.isArray(responseroles)) {
                    const respuestadatosroles = responseroles.map(item => `${item.id} - ${item.name}`);
                    data.roles = respuestadatosroles;

                    console.log("datos del select de roles", respuestadatosroles);
                } else {
                    console.error("Los datos cargados no son un array:", responseroles);
                }


            } catch (error) {
                console.error("Error al obtener la data de menu roles:", error);
            }
        });

        return { props, closeDialogChild, saveChild, data };
    },
    computed: {

        getValidationErrors() {
            return function (property) {
                if (this.props.errors_validate_parent && this.props.errors_validate_parent[property]) {
                    return this.props.errors_validate_parent[property][0];
                }
                return "";
            };
        },
    },
});
</script>